var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenLink = function SvgOpenLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.919 6.794 3.43 8.283a2.967 2.967 0 0 0 .031 4.229 2.97 2.97 0 0 0 2.121.9 2.9 2.9 0 0 0 2.108-.851l1.49-1.49m1.901-1.865 1.489-1.489a2.967 2.967 0 0 0-.031-4.229 3.02 3.02 0 0 0-2.12-.882 2.94 2.94 0 0 0-2.109.851l-1.489 1.49m-1.079 5.271 4.467-4.467"
  })));
};
export default SvgOpenLink;